export const defaultLoadableProps = {
  pastDelay: true,
  error: false,
  timedOut: false,
}
